import type { Actor } from '@/entities'

export const getActorImage = (actor: Actor | null | undefined) => {
    if (actor?.type !== 'user' && actor?.type !== 'contact') return null
    return actor.image?.resource ? actor.image : actor.type === 'contact' ? actor.user?.image ?? null : null
}
